module.exports = __webpack_public_path__ + "img/hu_get.cd0b359.png";